import styled from 'styled-components'
import CloseImg from '../../asset/close.svg'
import { CardText } from '../PageFooter/Footer.styled'
import theme from '../../styles/theme'

export const ModalContainer = styled.div`
  position: absolute;
  bottom: ${(props) => (props['aria-hidden'] ? '-50%' : '0px')};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  left: 0px;
  width: 100%;
  z-index: 99;
  padding: 0 20px 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  transition: bottom 0.3s ease-in-out;
  background: ${theme.color.white};
  box-shadow: inset 0px 2px 0px #808080;
  color: ${theme.color.black};
`

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const ModalTitle = styled.div`
  margin: 0;
  padding: 20px 30px 20px 0;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
`

export const CloseButton = styled.button`
  position: absolute;
  top: 2px;
  right 2px;
  width: 48px;
  height: 48px;
  vertical-align: middle;
  border-style: none;
  background: url(${CloseImg});
  &:focus {
    outline: 3px solid ${theme.color.focus};
    outline-offset: 1px;
  }
`

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  width: 100%;
`

export const ModalFooter = styled.div`
  padding: 10px 0px 15px 0px;
  width: 100%;
`
export const ModalText = styled(CardText)`
  & > p {
    margin-bottom: 10px;
  }
`
